import { Component, Input, Output, OnInit, EventEmitter, ChangeDetectionStrategy, Inject } from '@angular/core';
import { NgClass, NgIf, CurrencyPipe, DatePipe, NgForOf } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CarouselAllModule } from '@syncfusion/ej2-angular-navigations';
import { MatTabsModule } from '@angular/material/tabs';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaxSelectorDialogComponent } from '../pax-selector-dialog/pax-selector-dialog.component';
import { FormsModule } from '@angular/forms';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'adjustment',
  standalone: true,
  imports: [NgIf,FormsModule, MatIconModule, CarouselAllModule, MatTabsModule, CurrencyPipe, FuseDrawerComponent, MatButtonModule, GoogleMapsModule, DatePipe, MatTooltipModule, NgForOf, MatDialogModule, NgClass],
  providers: [TFMService],
  templateUrl: './adjustment-dialog.component.html',
  styleUrl: './adjustment-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Default
})
export class AdjustmentComponent implements OnInit {

  public view : any = {
    fee: {
      serviceSelected: '',
      service: '',
      cost: null,
      internalNote: ''
    }
  }
  /**
   * Constructor
   */
  constructor(private _tfmService : TFMService, private _tfmCartService: TFMCartService, public dialogRef: MatDialogRef<PaxSelectorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog)
  {
    // this.view.type = data.type;
    // this.view.search = data.search;
    // this.view.config = data.config;
    console.log('itenerary...',this.data)
  }

  /**
  * On init
  */
  ngOnInit(): void {
    
    
  }
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
        this.dialog.open(ConfirmationDialogComponent, {
          data: config
        });
      }
  private getItineraryDate(field: string, ...fallbacks: string[]): string | null {
    const itinerary = this.data?.itinerary;
    if (!itinerary) return null;
    for (const key of [field, ...fallbacks]) {
      if (itinerary[key]) return itinerary[key];
    }
    return null;
  }

  saveCustomItemToItin(itinGuid, item) {
    item.index = 99;
    item.price = item.cost;

    item.start = this.getItineraryDate('departDate', 'departureDate', 'startDate', 'start');
    item.end = this.getItineraryDate('returnDate', 'dateTo', 'endDate', 'end');

    if (item.serviceSelected != 'other') {
      item.service = item.serviceSelected;
    }

    if (item.id > 0) {
      //console.log("updating", item);
      this._tfmService.filterAndSend(item._links, "edit", item).subscribe(res => {
        // this.toaster.success("Service updated");
        console.log("Service updated",item)
        this.dialogRef.close({ adjustment: item });
          this.openConfirmationModal({
            title: 'Fee / Adjustment updated',
            message: 'The fee / adjustment has been updated successfully',
            showClose: true,
            showViewQuotes: false,
            showNewQuote: false
          });

        this.itinOptionsLoad();
      });
    }
    else {
      if (itinGuid) {
        this._tfmService.getItin(itinGuid).subscribe(res => {
          let link = this._tfmService.getLink(res.content.itinerary._links, "add-item-custom");
          link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);
          this._tfmService.send(link, item).subscribe(res => {
            //this.tripPointsGet();
            // this.itinOptionsLoad();
            console.log("Custom service added to itinerary",res)
            this.dialogRef.close({ adjustment: item });
            this.openConfirmationModal({
              title: 'Fee / Adjustment added',
              message: 'The fee / adjustment has been added successfully',
              showClose: true,
              showViewQuotes: false,
              showNewQuote: false
            });

            // this.toaster.info("Custom service added to itinerary");
          });
        });
      }
    }
  }
  itinOptionsLoad() {
    this._tfmService.getItinOptions(this.view.trip.itinerary.id).subscribe(resOptions => {

      this.view.trip.itinerary.options = resOptions.content;

      this.view.trip.itinerary.options.forEach(option => {
        this._tfmService.getItinItems(option.itinerary.guid).subscribe(optionItems => {
          option.itinerary.items = optionItems;

          this._tfmService.filterAndSend(option.itinerary._links, "payments").subscribe(res => {
            option.itinerary.payments = res;
          });
        });

        this.getPayments(option.itinerary);
        console.log("getPayments");
      });
    });
  }
  getPayments(itinerary) {
    this._tfmService.filterAndSend(itinerary._links, "payments").subscribe(res => {
      itinerary.payments = res;
    });
  }

  public apply() {
    this.dialogRef.close(this.view);
  }

  close(): void
  {
      // Close the dialog
      this.dialogRef.close();
  }

}
